import { useEffect } from "react";

import { Box, Stack, MenuItem } from "@mui/material";

import useLocalization from "../../hooks/useLocalization";

import Select from "../elements/Select";

const SurveyEntry_OutOfStock = ({ question, value, onChange, isDisabled }) => {
  const { getLabel, outofstock } = useLocalization();

  const handleChange = (field, newValue) => {
    let outofstockAnswers = {};

    if (value) {
      outofstockAnswers = { ...value, [field]: newValue };
    } else {
      outofstockAnswers = { [field]: newValue };
    }

    if (outofstockAnswers.shelfTagOnEntry === "true") {
      outofstockAnswers.shelfTagAdded = null;
    }

    onChange(outofstockAnswers);
  };

  return (
    <Stack
      spacing={1}
      sx={{ marginTop: "8px" }}
    >
      <Stack spacing={1}>
        <Select
          size="small"
          fullWidth
          label={outofstock.questionText.productOnShelfOnEntry}
          value={value?.productOnShelf}
          onChange={(newValue) => handleChange("productOnShelf", newValue)}
          items={outofstock.productOnEntry}
          disabled={isDisabled}
        />

        {value?.productOnShelf === "false" && (
          <Select
            size="small"
            fullWidth
            label={outofstock.questionText.productAdded}
            value={value?.productAdded}
            onChange={(newValue) => handleChange("productAdded", newValue)}
            items={outofstock.productAdded}
            disabled={isDisabled}
          />
        )}
      </Stack>
    </Stack>
  );
};

export default SurveyEntry_OutOfStock;
